import * as Yup from "yup";

const companySchema = {};

const validateMposApiKey = (fieldName) => {
  return Yup.string()
    .nullable()
    .max(100, `${fieldName} should be at most 100 characters.`)
    .test(
      `at-least-one-${fieldName.toLowerCase().replace(/\s+/g, "-")}`,
      "Either MPOS ERP API Key or Non-ERP API Key is required when MPOS Integration is enabled.",
      function () {
        const { mpos_integration, mpos_api_key, mpos_api_key_non_erp } =
          this.parent || {};
        if (Number(mpos_integration) === 1 || mpos_integration === "1") {
          const hasErp = mpos_api_key && String(mpos_api_key).trim().length > 0;
          const hasNonErp =
            mpos_api_key_non_erp &&
            String(mpos_api_key_non_erp).trim().length > 0;
          return Boolean(hasErp || hasNonErp);
        }
        return true;
      },
    );
};

companySchema.validateCompanyAdd = () => {
  return Yup.object({
    comp_name: Yup.string()
      .trim()
      .required("Company name is required.")
      .min(2, "Company name minimum length is 2")
      .max(50, "Company name should be at most 50 characters."),
    user_limit: Yup.string()
      .trim()
      .required("User Limit is required.")
      .test(
        "not-zero",
        "User Limit must be greater than 0",
        (value) => Number(value) > 0,
      ),
    expiry_date: Yup.string().trim().required("Expity Date is required."),

    tally_godown: Yup.string()
      .trim()
      .min(3, "Tally Godown minimum length is 3")
      .max(50, "Tally Godown should be at most 50 characters."),
    voucher_type: Yup.string()
      .trim()
      .min(3, "Voucher Type minimum length is 3")
      .max(50, "Voucher Type should be at most 50 characters."),
    sales_ledger: Yup.string()
      .trim()
      .min(3, "Sales Ledger minimum length is 3")
      .max(50, "Sales Ledger should be at most 50 characters."),
    expense_voucher_type: Yup.string()
      .trim()
      .max(45, "Expense Voucher Type should be at most 45 characters.")
      .nullable(),
    income_voucher_type: Yup.string()
      .trim()
      .max(45, "Income Voucher Type should be at most 45 characters.")
      .nullable(),
    cash_ledger: Yup.string()
      .trim()
      .max(45, "Cash Ledger should be at most 45 characters.")
      .nullable(),
    stock_voucher_type: Yup.string()
      .trim()
      .max(45, "Stock Voucher Type should be at most 45 characters.")
      .nullable(),
    roundoff_ledger: Yup.string()
      .trim()
      .max(45, "Roundoff Ledger should be at most 50 characters.")
      .nullable(),
    mpos_api_key: validateMposApiKey("MPOS ERP API Key"),
    mpos_api_key_non_erp: validateMposApiKey("MPOS Non-ERP API Key"),
  });
};

companySchema.validateCompanyEdit = () => {
  return Yup.object({
    comp_name: Yup.string()
      .trim()
      .required("Company name is required.")
      .min(2, "Company name minimum length is 2")
      .max(50, "Company name should be at most 50 characters."),
    // .matches(/^[aA-z0-9Z-\s]+$/, `Company name should be Alphanumeric only`),
    // comp_pincode: Yup.string()
    //   .required('Pincode is required.')
    //   .max(9, 'Pincode symbol should be at most 9 characters.')
    //   .min(5, 'Pincode symbol should be at most 5 characters.')
    //   .matches(/^[0-9\s]+$/, `Pincode code should be number`),
    // comp_state_id: Yup.string().required('Company state is required.'),
    // comp_city_id: Yup.string().required('Company city is required.'),
    tally_godown: Yup.string()
      .trim()
      .min(3, "Tally Godown minimum length is 3")
      .nullable()
      .max(50, "Tally Godown should be at most 50 characters."),
    voucher_type: Yup.string()
      .trim()
      .min(3, "Voucher Type minimum length is 3")
      .nullable()
      .max(50, "Voucher Type should be at most 50 characters."),
    sales_ledger: Yup.string()
      .trim()
      .min(3, "Sales Ledger minimum length is 3")
      .nullable()
      .max(50, "Sales Ledger should be at most 50 characters."),
    user_limit: Yup.string()
      .trim()
      .required("User Limit is required.")
      .test(
        "not-zero",
        "User Limit must be greater than 0",
        (value) => Number(value) > 0,
      ),
    expiry_date: Yup.string().trim().required("Expity Date is required."),
    expense_voucher_type: Yup.string()
      .trim()
      .max(45, "Expense Voucher Type should be at most 45 characters.")
      .nullable(),
    income_voucher_type: Yup.string()
      .trim()
      .max(45, "Income Voucher Type should be at most 45 characters.")
      .nullable(),
    cash_ledger: Yup.string()
      .trim()
      .max(45, "Cash Ledger should be at most 45 characters.")
      .nullable(),
    stock_voucher_type: Yup.string()
      .trim()
      .max(45, "Stock Voucher Type should be at most 45 characters.")
      .nullable(),
    roundoff_ledger: Yup.string()
      .trim()
      .max(45, "Roundoff Ledger should be at most 45 characters.")
      .nullable(),
    mpos_api_key: validateMposApiKey("MPOS ERP API Key"),
    mpos_api_key_non_erp: validateMposApiKey("MPOS Non-ERP API Key"),
  });
};

export default companySchema;
